<template>
    <div id="app" :class="{'fd-com-hide-bar': hideBar}">
<!--      <yzwLogin></yzwLogin>-->
        <keep-alive>
            <router-view class="fd-com-page" v-if="$route.meta.keepAlive && showRouter">
            </router-view>
        </keep-alive>
        <router-view class="fd-com-page" v-if="!$route.meta.keepAlive && showRouter">
        </router-view>
        <div class="fd-com-nodata">
            {{ errorTip }}
        </div>
        <van-number-keyboard safe-area-inset-bottom/>
    </div>
</template>

<script>
    import {AxiosGetHome} from "@/api/home";
    import {setToken} from "@/utils/auth";
    export default {
        data() {
            return {
                // 是否隐藏顶部标题栏和底部bar（嵌入在线服务小程序时，不需要显示）
                hideBar: true,
                // 是否加载router页面（为嵌入在线服务小程序新增，解决对接token与加载页面的先后顺序问题）
                showRouter: false,
                // 报错提示语
                errorTip: ''
            };
        },
        // watch: {
        //     // 监听路由变化（解决vue的机制问题，路由参数变化，数据不刷新的问题）
        //     $route() {
        //       console.log("watch触发init------>");
        //         this.init();
        //     }
        // },
        created() {
          console.log("created触发init------>");
            this.init();
        },

        methods: {

            /**
             * @function
             * @description 初始化数据
             * @return {undefined} 无返回值
             */
            init() {
                // 等router加载完，不然值传了，有时会取不到
                this.$router.onReady(() => {
                    // url上不带code参数时，不重新对接在线服务与保全系统的token
                    if (!this.$route.query.code) {
                        this.showRouter = true;
                        console.log('url上未识别到code传参');
                        return;
                    }
                    const params = {
                        code: this.$route.query.code,
                        type: 'yzw',
                        state: this.$route.query.state
                    };

                    if (this.$route.query.code) {
                      console.log("通过code发送请求1------>");
                        AxiosGetHome('/account/getauthorization', params).then((res) => {
                          console.log("res----->", res)
                            if (res.code === 200) {
                                setToken(res.data.token);
                                this.showRouter = true;
                              // this.$router.push({
                              //   path: "/home/myPreservation",
                              // });
                            } else {
                                const errorMessage = res.message ? res.message : '该用户无权限访问';
                                this.$notify(errorMessage);
                                this.showRouter = false;
                                this.errorTip = errorMessage;
                            }
                        });
                    }
                    // 对接在线服务网——判断路由url上是否携带了在线服务的token（与保全系统是不同的token值）
                    if (this.$route.query.zxfwtoken) {
                        localStorage.setItem('zxfwtoken', this.$route.query.zxfwtoken);
                        // 不显示头部，因为嵌入在线服务的小程序的webview顶部自带头
                        localStorage.setItem('hideBar', this.hideBar);
                    }
                });
            }
        }
    }
</script>
